/**
 * Basic SAILS storage interface
 */
export interface SailsGkLandingpageStorage {
    /**
     * Active Option Tabs selected
     */
    multipickerSelection: string;
}
